import React from "react";
import { useSpring, animated } from "@react-spring/web";

const FallingBoard = () => {
  const springProps = useSpring({
    from: { y: -80, rotateZ: -3 },
    to: { y: 0, rotateZ: 2 },
    config: { mass: 1, tension: 180, friction: 14 },
  });

  return (
    <div className="relative h-32 flex justify-center items-start">
      {/* Left Rope - Shorter */}
      <animated.div
        className="absolute w-[2px] h-6 bg-gray-300"
        style={{
          top: "0",
          left: "calc(50% - 40px)",
          transformOrigin: "top",
          transform: springProps.rotateZ.to((r) => `rotate(${r * -1}deg)`),
        }}
      />
      {/* Right Rope - Shorter */}
      <animated.div
        className="absolute w-[2px] h-8 bg-gray-300"
        style={{
          top: "0",
          left: "calc(50% + 40px)",
          transformOrigin: "top",
          transform: springProps.rotateZ.to((r) => `rotate(${r}deg)`),
        }}
      />

      {/* Animated Board */}
      <animated.div
        className="absolute top-6 left-1/2 w-24 h-12 bg-gray-100 flex items-center justify-center text-xs  rounded-lg shadow-lg border border-gray-300 text-center"
        style={{ transform: "translateX(-50%)", ...springProps }}
      >
        ساعت کاری
        <br />
        8:00 تا 22:00
      </animated.div>
    </div>
  );
};

export default FallingBoard;
